"use client";

import React from 'react';

export interface DesktopShowcaseBlockProps {
    viewportLabel?: string;
    typeLabel?: string;
    url?: string;
    imageUrl?: string;
    style?: {
        backgroundColor?: string;
        paddingTop?: string;
        paddingBottom?: string;
    };
}

export default function DesktopShowcaseBlock({
    viewportLabel = "Desktop Viewport [1280px]",
    typeLabel = "Actual Website Screenshot",
    url = "https://crowntownhotel.com",
    imageUrl = "/images/crowntown_full_screenshot.jpg",
    style = {}
}: DesktopShowcaseBlockProps) {
    const bg = style.backgroundColor || "#09090A";

    return (
        <div 
            className="w-full px-6 md:px-12 lg:px-24"
            style={{
                backgroundColor: bg,
                paddingTop: style.paddingTop || "7rem",
                paddingBottom: style.paddingBottom || "7rem",
            }}
        >
            <div className="container mx-auto">
                {/* Label */}
                <div className="mb-6 flex justify-between items-center max-w-5xl mx-auto">
                    <span className="text-[11px] font-mono text-zinc-400 tracking-wider">
                        {viewportLabel}
                    </span>
                    {typeLabel && (
                        <span className="text-[10px] font-mono text-zinc-500">
                            {typeLabel}
                        </span>
                    )}
                </div>

                {/* Desktop Screenshot */}
                <div className="w-full max-w-5xl mx-auto rounded-2xl overflow-hidden border border-zinc-850 bg-zinc-950 p-2 shadow-[0_30px_70px_rgba(0,0,0,0.8)]">
                    {/* Chrome Window Browser UI */}
                    <div className="w-full h-10 bg-zinc-900 border border-zinc-850 rounded-t-xl flex items-center px-4 justify-between">
                        <div className="flex gap-1.5 items-center">
                            <div className="w-3 h-3 rounded-full bg-red-500/80" />
                            <div className="w-3 h-3 rounded-full bg-yellow-500/80" />
                            <div className="w-3 h-3 rounded-full bg-green-500/80" />
                        </div>
                        {url && (
                            <div className="h-6 bg-zinc-950 px-12 rounded-md text-[10px] font-mono text-zinc-500 flex items-center border border-zinc-900 gap-2 select-none">
                                <span className="text-zinc-700">https://</span>
                                {url.replace(/^https?:\/\//, "")}
                            </div>
                        )}
                        <div className="w-16" /> {/* Spacer */}
                    </div>

                    {/* Full Page View */}
                    <div className="relative w-full bg-zinc-950">
                        {imageUrl && (
                            <img 
                                src={imageUrl} 
                                alt="Live Website Screenshot" 
                                className="w-full h-auto block rounded-b-xl"
                                loading="lazy"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
